import React from 'react';
import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Dialog from '@mui/material/Dialog';
import Typography from '@mui/material/Typography';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import './classroomLaunchScreen.css';
import '../sound-hunt/classroomTrainBackdrop.css';

const TITLES = {
  train: 'Hece Treni',
  balloon: 'Balon Patlat',
  wheel: 'Hece & Kelime Çarkı',
};

/**
 * Immediate, full-viewport activity shell while the initial read-only request
 * resolves. Never render the generic white MUI title/content dialog (or expose
 * the dashboard behind it) while a classroom game is opening.
 */
export default function ClassroomLaunchScreen({ game, error, onRetry, onClose, busy = false }) {
  const title = TITLES[game] || 'DANDU Etkinliği';
  return <Dialog open fullScreen transitionDuration={0} onClose={onClose}
    aria-labelledby="classroom-launch-title"
    PaperProps={{ className: `classroom-launch-paper classroom-launch-paper--${game}` }}>
    <Box className="classroom-launch-scene">
      <Box className="classroom-launch-header">
        <Box className="classroom-launch-title-group">
          <Typography component="h2" id="classroom-launch-title">{title}</Typography>
          {game === 'train' && <Typography className="classroom-launch-subtitle">Harfleri sırayla vagonlara yerleştir!</Typography>}
          {game === 'wheel' && <Typography className="classroom-launch-subtitle">Hadi çarkı çevir, birlikte okuyalım!</Typography>}
        </Box>
        <Button onClick={onClose} startIcon={<CloseRoundedIcon />} className="classroom-launch-close">Kapat</Button>
      </Box>
      <Box className="classroom-launch-center">
        {error ? <>
          <Alert severity="error" role="alert" className="classroom-launch-error">{error}</Alert>
          <Button onClick={onRetry} disabled={busy} className="classroom-launch-retry">Tekrar Dene</Button>
        </> : <Box role="status" aria-live="polite" className="classroom-launch-loading">
          <CircularProgress aria-hidden="true" size={56} thickness={4} />
          <Typography>Oyunumuz hazırlanıyor…</Typography>
        </Box>}
      </Box>
    </Box>
  </Dialog>;
}
